import axios from 'axios'
import { axiosConfig } from '@/config/axiosConfig.js'

// export async function get_my_favorites (client_name) {
//     const response = await axios.get(`${client_name}/webmap/get_my_favorites/`, axiosConfig);
//     try {
//         const result = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
//         return result;

//     } catch (error) {
//         console.error(error);
//     }
// }

export async function update_my_favorites (client_name, send_data) {
    const response = await axios.post(`${client_name}/rainmonitor/update_my_favorites/`, send_data, axiosConfig);
    try {
        const result = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
        return result;

    } catch (error) {
        console.error(error);
    }
}